import React, {useContext, useEffect} from "react";
import Axios from 'axios';
import {useHistory} from "react-router-dom";
import Loading from "./Loading";
import AuthContext from "../context/AuthContext";


function Callback() {

    const {isAuth, authToken, isMaster} = useContext(AuthContext)

    const history = useHistory();

    useEffect(() => {
        if (isAuth) {

            Axios.post(process.env.REACT_APP_AUTH0_AUDIENCE, {
                    query: `query MyQuery {
                                      General_DatosAsesores {
                                        idDatos
                                      }
                                    }`
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    }
                }).then((result) => {
                    // console.log(result)
                    if (result.data.data.General_DatosAsesores[0] === undefined) {
                        history.push('/validate-passphrase');
                    }
                        else if (isMaster) { //isMaster is true when the Auth0 Claims includes 'master' as user role
                            history.push('/u/m/dashboard');
                    }
                    else {
                        // setUserTest('hola')
                        history.push(`/u/dashboard`);

                    }

                    // });
                }
            );
        } else {
            history.push('/');
        }
    },[authToken, history, isAuth]);

    return (
        <Loading/>
    )
}

export default Callback;
